import { HTMLAttributes, useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import { useRouter } from 'next/router'

import Footer from '@/components/layout/footer'
import Header from '@/components/layout/header'
import { LenisProvider } from '@/contexts/lenis'
import { SchemaProvider } from '@/contexts/schema'
import TransitionProvider from '@/contexts/transition/transition-provider'
import { useLocaleStore } from '@/store/locale'

import { WPPageData } from '@/types'

export type LayoutProps = HTMLAttributes<HTMLDivElement> & {
  pageProps?: WPPageData
}

const Layout = ({ pageProps, children, ...props }: LayoutProps) => {
  const router = useRouter()
  const schema = useMemo(() => pageProps?.yoast_head_json?.schema, [pageProps])
  const setCurrentTranslations = useLocaleStore((state) => state.setCurrentTranslations)
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)

  useEffect(() => {
    setCurrentLocale(router.locale)
  }, [router.locale, setCurrentLocale])

  useEffect(() => {
    setCurrentTranslations(pageProps?.wpml_translations || [])
  }, [pageProps, setCurrentTranslations])

  return (
    <SchemaProvider schema={schema}>
      <LenisProvider {...props}>
        <Header />
        <TransitionProvider>
          <Box sx={{ pt: (theme) => theme.customSizes.headerHeight }}>{children}</Box>
        </TransitionProvider>
        <Footer />
      </LenisProvider>
    </SchemaProvider>
  )
}

export default Layout
